import { List as ImmutableList } from 'immutable';
import Recipient from '../records/Recipient';
export const buildRecipients = (recipients = []) => {
  return ImmutableList().withMutations(mutableList => {
    recipients.forEach(recipient => {
      mutableList.push(Recipient(recipient));
    });
  });
};